"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareCommitMessage = exports.getMessageDataLength = exports.CHANGESET_TYPE = void 0;
var util_1 = require("../util");
/**
 * 业务数据子类型（比如在sheet里嵌入smartsheet）
 */
var CHANGESET_TYPE;
(function (CHANGESET_TYPE) {
    CHANGESET_TYPE["SMARTSHEET"] = "smartsheet";
    CHANGESET_TYPE["SMARTCANVAS"] = "smartcanvas";
})(CHANGESET_TYPE || (CHANGESET_TYPE = {}));
exports.CHANGESET_TYPE = CHANGESET_TYPE;
function getMessageDataLength(data) {
    var _a;
    if (data) {
        if (data instanceof Object) {
            return ((_a = data.changeset) === null || _a === void 0 ? void 0 : _a.length) || 0;
        }
        return data.length || 0;
    }
    return 0;
}
exports.getMessageDataLength = getMessageDataLength;
function prepareCommitMessage(data, uuid, pver) {
    if (typeof data === 'string')
        return data;
    var messageData = __assign(__assign({}, data), { type: 'USER_CHANGES', baseRev: data.baseRev, changeSetCount: data.changeSetCount, changeset: data.changeset, apool: data.apool, isWorkbook: data.isWorkbook, keydata: data.keydata || false, head: data.head, subId: data.subId, changesetType: data.changesetType, oSubId: data.oSubId || false, uuId: uuid, offlineMsg: data.offlineMsg, pver: pver });
    return util_1.JsonUtil.jsonStringify(messageData);
}
exports.prepareCommitMessage = prepareCommitMessage;
